/**
 * 将base64字符串转为对应的arrayBuffer对象
 * @function base64ToArrayBuffer
 * @memberof Utils
 * @param {string} base64 - base64编码的字符串
 * @returns {arrayBuffer} 二进制utf8的arraybuffer
 */
export function base64ToArrayBuffer(base64: string) {
  const binary_string = window.atob(base64);
  const len = binary_string.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes;
}

/**
 * 将ArrayBuffer转为对应的base64字符串
 * @function arrayBufferToBase64
 * @memberof Utils
 * @param {arrayBuffer} buffer - 二进制buffer对象
 * @returns {string}  base64编码的字符串
 */
export function arrayBufferToBase64(buffer: ArrayBuffer) {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  console.log("bytesbytesbytesbytes", bytes);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

/**
 * Creates a new ArrayBuffer from concatenating two existing ones
 *
 * @param {ArrayBuffer | null} buffer1 The first buffer.
 * @param {ArrayBuffer | null} buffer2 The second buffer.
 * @return {ArrayBuffer | null} The new ArrayBuffer created out of the two.
 */
export function concatArrayBuffers(
  buffer1: ArrayBuffer | null,
  buffer2: ArrayBuffer | null
) {
  if (!buffer1) {
    return buffer2;
  } else if (!buffer2) {
    return buffer1;
  }

  const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
  tmp.set(new Uint8Array(buffer1), 0);
  tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
  return tmp.buffer;
}

/**
 * unit8array的下标，设置int32的值
 * @param {Uint8Array | null} buffer1 The first buffer.
 * @param {Number | null} index index
 * @param {Number | null} result int32 value
 */
export function writeBigEndianUnit8Array(
  unit8array: Uint8Array,
  index: number,
  result: number
) {
  unit8array[index * 4] = (result >> 24) & 255;
  unit8array[index * 4 + 1] = (result >> 16) & 255;
  unit8array[index * 4 + 2] = (result >> 8) & 255;
  unit8array[index * 4 + 3] = result & 255;
}

/**
 * unit8array的下标，设置int32的值
 * @param {Uint8Array | null} buffer1 The first buffer.
 * @param {Number | null} index index
 * @return {Number | null} int32 value
 */
export function readBigEndianUnit8Array(unit8array: Uint8Array, index: number) {
  const buf0 = unit8array[index * 4];
  const buf1 = unit8array[index * 4 + 1];
  const buf2 = unit8array[index * 4 + 2];
  const buf3 = unit8array[index * 4 + 3];

  return buf3 | (buf2 << 8) | (buf1 << 16) | (buf0 << 24);
}

export function packLonglinkPacket(
  seq: number,
  cmdid: number,
  bodyLength: number
) {
  const headBuffer = new Uint8Array(20);
  writeBigEndianUnit8Array(headBuffer, 0, 20);
  writeBigEndianUnit8Array(headBuffer, 1, 0);
  writeBigEndianUnit8Array(headBuffer, 2, cmdid);
  writeBigEndianUnit8Array(headBuffer, 3, seq);
  writeBigEndianUnit8Array(headBuffer, 4, bodyLength);
  return headBuffer;
}

export function unpackLonglinkPacket(bytes: Uint8Array, offset: number) {
  const headerLen = readBigEndianUnit8Array(bytes, offset);
  const clientVer = readBigEndianUnit8Array(bytes, offset + 1);
  const cmdid = readBigEndianUnit8Array(bytes, offset + 2);
  const seq = readBigEndianUnit8Array(bytes, offset + 3);
  const bodyLength = readBigEndianUnit8Array(bytes, offset + 4);

  return {
    headerLen: headerLen,
    clientVer: clientVer,
    cmdid: cmdid,
    seq: seq,
    bodyLength: bodyLength,
    bodyData: bytes.slice(offset + headerLen, offset + headerLen + bodyLength),
  };
}
